<template>
  <div class="ac-body-container">
    <div class="header">
      Support Contacts
    </div>
    <div class="sub-header">
      Enter the support contact you would like your members to contact to
    </div>
    <div class="ac-input-container margin-top-4">
      <div class="ac-input-header">
        Email
      </div>
      <SACInput
        field="email"
        placeholder="Enter email"
        :value="email"
        :change="onChange"
        :error="errorObj.emailErr"
      />
    </div>
    <div class="ac-input-container margin-top-4">
      <div class="ac-input-header">
        Phone
      </div>
      <SACInput
        field="phone"
        placeholder="Enter phone"
        :value="phone"
        :change="onChange"
        :error="errorObj.phoneErr"
      />
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import SACInput from '@shared/components/sac/SACInput.vue';

export default {
  name: 'SupportContact',
  components: {
    SACInput,
  },
  mixins: [partnerSettingsMixin],
  props: {
    email: String,
    phone: String,
    onChange: Function,
    errorObj: Object,
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 1rem;
  font-weight: 700;
  color: $N80;
}
.sub-header {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
}

.ac-row-container {
  display: flex;
  max-width: 500px;
  .ac-input-container:last-child {
    margin-right: 0;
  }
}
</style>
